import React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Index from '../Index';
import './App.css';

function App() {
    const basename = process.env.REACT_APP_BASENAME || null;
    return (
        <Router basename={basename}>
            <Switch>
                <Route
                    exact
                    name="index"
                    path="/:lang/:projectId/stand/:standId"
                    component={Index}
                />
                <Route
                    exact
                    name="index"
                    path="/:lang/:projectId/map/:mapId"
                    component={Index}
                />
                <Route
                    exact
                    name="index"
                    path="/:lang/:projectId/mapXY/:mapId/:locationX/:locationY"
                    component={Index}
                />
                <Route
                    exact
                    name="index"
                    path="/:lang/:projectId/area/:areaId"
                    component={Index}
                />
            </Switch>
        </Router>
    );
}

export default App;
